import { PreconditionError } from '@crowdex/agent-contracts';
import { apiClientErrorFromBody } from '@crowdex/host-kit/renderer/http';

/** Electron's wrapper around errors thrown by main-process IPC handlers; it names the channel, not the problem. */
const IPC_ERROR_ENVELOPE = /^Error invoking remote method '[^']+': (?:\w*Error: )?/;

/** A failure message as a person should read it, without Electron's IPC wrapper. */
export function readableErrorMessage(message: string): string {
  return message.replace(IPC_ERROR_ENVELOPE, '');
}

/** Extract a human-readable message from an unknown thrown value. */
export function errorMessage(cause: unknown): string {
  return readableErrorMessage(cause instanceof Error ? cause.message : String(cause));
}

/** A refused request's body, whatever its shape: the person reads the message, not the JSON. */
export function responseErrorMessage(body: string, status = 500): string {
  return apiClientErrorFromBody(status, body).message;
}

/**
 * The error of a request another Crowdex server refused, to rethrow here: a precondition keeps
 * its code and reason (so this server answers the same), anything else keeps its message.
 */
export function upstreamFailure(status: number, body: string): Error {
  const failure = apiClientErrorFromBody(status, body);
  if (
    failure.reason !== null &&
    (failure.code === 'unconfigured' || failure.code === 'unavailable')
  )
    return new PreconditionError(failure.code, failure.reason, failure.message);
  return new Error(failure.message);
}
